import { useOktaAuth } from "@okta/okta-react";
import { useHistory } from "react-router";

export default function Sso() {
    const { oktaAuth } = useOktaAuth();
    const history = useHistory();

    oktaAuth.signInWithRedirect({}).catch(() => {
        history.push("/");
    });

    return null;
}
